import type { ScenarioItemFilters } from '@/lib/api/adaptive-planner/scenarioItemFilters';

export const loopPlannerQueryKeys = {
  sandbox: {
    current: ({ loopId }: { loopId: number }) => ['loop-planner', 'sandbox', loopId],
  },
  scenarios: {
    list: ({ loopId }: { loopId: number }) => ['loop-planner', 'scenarios', loopId],
    detail: ({ loopId, scenarioId }: { loopId: number; scenarioId: number }) => [
      'loop-planner',
      'scenarios',
      loopId,
      scenarioId,
    ],
  },
  scenarioAlerts: {
    root: () => ['loop-planner', 'scenario-alerts'],
    allAlerts: ({ scenarioId }: { scenarioId: number }) => [
      ...loopPlannerQueryKeys.scenarioAlerts.root(),
      scenarioId,
    ],
    alerts: ({
      scenarioId,
      loopId,
      alertTypes,
    }: {
      scenarioId: number;
      loopId: number;
      alertTypes?: string[];
    }) => [...loopPlannerQueryKeys.scenarioAlerts.allAlerts({ scenarioId }), loopId, alertTypes],
  },
  scenarioChangeSummary: {
    root: ({ scenarioId }: { scenarioId: number }) => [
      'loop-planner',
      'scenario-change-summary',
      scenarioId,
    ],
    detail: ({ scenarioId, loopId }: { scenarioId: number; loopId: number }) => [
      ...loopPlannerQueryKeys.scenarioChangeSummary.root({ scenarioId }),
      loopId,
    ],
  },
  timelineItems: {
    root: ({ loopId, scenarioId }: { loopId: number; scenarioId: number }) => [
      'loop-planner',
      loopId,
      'scenario',
      scenarioId,
      'timeline-items',
    ],
    dataSet: ({
      loopId,
      scenarioId,
      filters,
    }: {
      loopId: number;
      scenarioId: number;
      filters?: ScenarioItemFilters;
    }) => [
      ...loopPlannerQueryKeys.timelineItems.root({ loopId, scenarioId }),
      'data-set',
      filters ?? {},
    ],
    imputedCount: ({ loopId, scenarioId }: { loopId: number; scenarioId: number }) => [
      ...loopPlannerQueryKeys.timelineItems.root({ loopId, scenarioId }),
      'count',
      'imputed',
    ],
    bulkFetch: ({
      loopId,
      scenarioId,
      itemIds,
    }: {
      loopId: number;
      scenarioId: number;
      itemIds: number[];
    }) => {
      const sortedItemIds = [...itemIds].sort((a, b) => a - b);
      return [
        ...loopPlannerQueryKeys.timelineItems.root({ loopId, scenarioId }),
        'bulk-fetch',
        sortedItemIds.join(','),
      ];
    },
  },
  scenarioItems: {
    root: ({ loopId, scenarioId }: { loopId: number; scenarioId: number }) => [
      'loop-planner',
      loopId,
      'scenario',
      scenarioId,
      'scenario-items',
    ],
    detail: ({
      loopId,
      scenarioId,
      itemId,
    }: {
      loopId: number;
      scenarioId: number;
      itemId: number;
    }) => [...loopPlannerQueryKeys.scenarioItems.root({ loopId, scenarioId }), itemId],
    ancestors: ({
      loopId,
      scenarioId,
      itemId,
    }: {
      loopId: number;
      scenarioId: number;
      itemId: number;
    }) => [
      ...loopPlannerQueryKeys.scenarioItems.detail({ loopId, scenarioId, itemId }),
      'ancestors',
    ],
  },
};
